import { Component, Input, OnInit } from '@angular/core';
import { ReqService, TripadvisorService } from '@core/services';
import { ITripdavisorReviews } from '@core/models/tripadvisor';
import moment from 'moment';
import { MbReviewsRatingModule, MbBarRatingModule, MbCommentsModule } from '@am/moebius';
import { NgIf, NgFor } from '@angular/common';

@Component({
    selector: 'tripadvisor-reviews',
    templateUrl: './tripadvisor-reviews.component.html',
    styleUrls: ['./tripadvisor-reviews.component.scss'],
    standalone: true,
    imports: [
        NgIf,
        MbReviewsRatingModule,
        NgFor,
        MbBarRatingModule,
        MbCommentsModule,
    ],
})
export class TripadavisorReviewsComponent implements OnInit {
  @Input() data: any;

  public busy: boolean;
  public tripadvisorReviews: ITripdavisorReviews;
  private language: string;
  private evaluationLabels: Map<number, string>;

  constructor(
    private reqService: ReqService,
    private tripadvisorService: TripadvisorService,
  ) {
    this.evaluationLabels = new Map([
      [5, 'REGULAR'],
      [6, 'ACEPTABLE'],
      [7, 'BUENO'],
      [8, 'MUY BUENO'],
      [9, 'EXCELENTE'],
      [10, 'FANTÁSTICO'],
      [-1, 'SIN PUNTUACIÓN'],
    ]);
  }

  ngOnInit() {
    this.language = this.reqService.getLocale();
    this.busy = true;
    this.tripadvisorService.getReviews(this.data.id).subscribe(
      (res) => {
        this.busy = false;
        this.tripadvisorReviews = this.dateTransform(res);
        const rating = Math.floor(this.tripadvisorReviews.rating);
        this.tripadvisorReviews.ratingLabel = this.evaluationLabels.has(rating)
          ? this.evaluationLabels.get(rating)
          : this.evaluationLabels.get(-1);
      },
      (error) => console.error(error),
    );
  }

  private dateTransform(res) {
    res.reviews.map((review) => {
      moment.locale(this.language);
      review.published_date = moment(review.published_date).format('MMMM YYYY');
      review.user = review.user.user_name ? review.user.user_name : 'Usuario anónimo';
      return review;
    });
    return res;
  }
}
